import { isRejected, AnyAction, Middleware } from '@reduxjs/toolkit'

import { handleRequestError } from '@/actions'

import { apiSlice } from './api-slice'

/**
 * Check if the action is from inside of the main app, by the api-slice.
 * Other slices may dispatch actions with different structure, thus Bookkeeping API should be ignored for now.
 */
const getIsActionFromApiSlice = (action: AnyAction) => {
    const actionType = (action?.type || '') as string
    return actionType.startsWith(apiSlice.reducerPath)
}

const getShouldHandleRejectedAction = (action: AnyAction) => {
    return getIsActionFromApiSlice(action) && isRejected(action) && action.error?.name !== 'ConditionError'
}

export const apiRequestInterceptorMiddleware: Middleware = (api) => (next) => (action) => {
    if (getShouldHandleRejectedAction(action)) {
        if (action.payload?.status !== 404) {
            handleRequestError(action.payload)(api.dispatch)
        }
    }

    return next(action)
}
